import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ButtonComponent {
  @Input() public gtmTag = '';
  @Input() public buttonText = '';
  @Input() public buttonId = '';
  @Input() public buttonClassName = '';
  @Input() public isDisabled = false;
  @Input() public isSecondary = false;
  @Input() public isExternalOperation = false;

  @Output() public handleClick: EventEmitter<MouseEvent> =
    new EventEmitter<MouseEvent>();
}
